import apiResponse from '@/libs/apiResponse'

export default {
  data() {
    return {
      showExcelDownloadModal: false,
      excelLoading: false,
      warehouseExcelLoading: false,
      confirmModalMessage: '',
    }
  },
  methods: {
    async handleExcelDownload() {
      this.showExcelDownloadModal = true
      this.excelLoading = true

      try {
        const response = await fetch(this.excelDownloadUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            Accept: 'application/json',
          },
          credentials: 'include',
          redirect: 'manual',
        })

        if (response.status >= 300 && response.status < 400) {
          const redirectUrl = response.headers.get('Location')
          apiResponse.triggerDownload(redirectUrl)
          this.excelLoading = false
          return
        }

        if (response.type === 'opaqueredirect') {
          apiResponse.triggerDownload(this.excelDownloadUrl)
          this.excelLoading = false
          return
        }

        const contentType = response.headers.get('content-type')

        if (contentType && contentType.includes('application/json')) {
          const json = await response.json()
          this.confirmModalMessage = json.message
          this.excelLoading = false
          this.$bvModal.show('excel-download-modal')
        }
      } catch (error) {
        this.excelLoading = false
      }
    },
    async handleWarehouseExcelDownload() {
      this.showExcelDownloadModal = true
      this.warehouseExcelLoading = true

      try {
        const response = await fetch(this.warehouseExcelUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            Accept: 'application/json',
          },
          credentials: 'include',
          redirect: 'manual',
        })

        if (response.status >= 300 && response.status < 400) {
          const redirectUrl = response.headers.get('Location')
          apiResponse.triggerDownload(redirectUrl)
          this.warehouseExcelLoading = false
          return
        }

        if (response.type === 'opaqueredirect') {
          apiResponse.triggerDownload(this.warehouseExcelUrl)
          this.warehouseExcelLoading = false
          return
        }

        const contentType = response.headers.get('content-type')

        if (contentType && contentType.includes('application/json')) {
          const json = await response.json()
          this.confirmModalMessage = json.message
          this.warehouseExcelLoading = false
          this.$bvModal.show('excel-download-modal')
        }
      } catch (error) {
        this.confirmModalMessage = error
        this.warehouseExcelLoading = false
        this.$bvModal.show('excel-download-modal')
      }
    },
  },
}
